import React from "react";

export const DIRHAM_ICON_URL =
  "https://customer-assets.emergentagent.com/job_ddf-landing/artifacts/bd6v5efy_UAE%20Dirhams.png";

/**
 * Format a number with thousands separators (commas) and 2 decimals.
 * 1000 → "1,000.00", 44.25 → "44.25"
 */
export function formatPrice(value) {
  const n = Number(value) || 0;
  return n.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

/**
 * Inline Dirham icon. Uses CSS mask so color inherits from `currentColor`,
 * letting parents control hue. By default it adopts the surrounding text
 * color — wrap in a red element to render red, etc.
 */
export function DirhamIcon({ size = "0.95em", style = {}, className = "" }) {
  return (
    <span
      className={`ddf-dirham-icon ${className}`}
      role="img"
      aria-label="Dirham"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        verticalAlign: "-0.08em",
        marginRight: 4,
        backgroundColor: "currentColor",
        WebkitMaskImage: `url(${DIRHAM_ICON_URL})`,
        maskImage: `url(${DIRHAM_ICON_URL})`,
        WebkitMaskSize: "contain",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        maskPosition: "center",
        ...style,
      }}
    />
  );
}

/**
 * Display: <DirhamIcon /> 1,234.56
 */
export function Price({ value, className, style }) {
  return (
    <span className={className} style={style}>
      <DirhamIcon /> {formatPrice(value)}
    </span>
  );
}
